const getters = {
    permission_routes: state => state.permission.routes,
    permission_sidebar: state => state.permission.sidebar,
    user_roles: state => state.user.roles,
    permission_siteId: state => state.permission.siteId,
    user_userInfo: state => state.user.userInfo,
  }
  export default getters
  